import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
// import { GameDefinitionData } from '../../data/GameDefinitionData'
import { Board } from '../../data/Board';
import TableLine from './TableLine';

import {
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
    X,
} from '../../Constants/assets';
/* eslint-disable react/jsx-props-no-spreading */

// import { GeneralInfo } from '../index';

// Stylings
const MainContainer = styled.div`
    width: 90%;
    height: 85%;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    position: absolute;
`;
const InnerContainer = styled.div`
    width: 70.5%;
    height: 95%;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    background: ${props => props.theme.colors.white};
    z-index: 900;
`;
const HeaderContainer = styled.div`
    height: 19%;
    width: 98%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
const TitleContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 35%;
    align-items: flex-end;
`;
const XContainer = styled.div`
    height: 50%;
    cursor: pointer;
`;
const Title = styled.h1`
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    width: 92.5%;
`;
const ParagraphContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 50%;
    align-items: center;
    width: 95%;
`;
const Paragraph = styled.p`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    width: 92.5%;
    color: ${props => props.theme.colors.black};
`;
const GameDefinitionsMainContainer = styled.div`
    height: 75%;
    display: flex;
    flex-direction: column;
`;
const FirstLineContainer = styled.div`
    display: grid;
    grid-template-columns: 10.8% 22.4% 14.4% 17.5% 17% 15%;
    width: 95%;
    height: 5.5%;
`;
const FirstLineItem = styled.p`
    font-size: 12px;
    line-height: 14.06px;
    color: #81818c;
    display: flex;
`;
const ManImages = styled.div`
    width: 10%;
    height: 3.52187833511206vh;
    padding-left: 5px;
`;
const RedMan = styled(RedSource)`
    height: 45%;
`;
const GreenMan = styled(GreenSource)`
    height: 45%;
    margin-left: 10px;
`;
const WhiteMan = styled(WhiteSource)`
    height: 45%;
`;
const TableContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

export default function GameDefinitions({
    title,
    paragraph,
    toggleGameDefinitions,
    gameDefinitionsShow,
}) {
    const { t } = useTranslation();
    // extract data from Board.js and convert it to usable game definition
    let GameDefinitionData = Board.map((item, index) => {
        if (item.type === 'mile-stone' && item.milestone !== undefined) {
            return {
                id: item.id,
                name: 'milestone',
                icon: 200,
                Additional: item.milestone.id,
                Cost: item.milestone.resources.budget,
                blueAmount: item.milestone.resources.standard,
                greenAmount: item.milestone.resources.expensive,
                redAmount: item.milestone.resources.senior,
                // tableOrder is used just to visually separate milestones and gates in the table
                tableOrder: item.milestone.id,
            };
        }
        if (item.type === 'gate' && item.gate !== undefined) {
            return {
                id: item.id,
                name: 'gate',
                icon: 200,
                Additional: item.gate.id,
                Cost: item.gate.resources.budget,
                blueAmount: item.gate.resources.standard,
                greenAmount: item.gate.resources.expensive,
                redAmount: item.gate.resources.senior,
                tableOrder: item.gate.id,
            };
        }
    });

    // sort out undefined objects (the map function from before returns null as default even if you don't want to return anything)
    GameDefinitionData = GameDefinitionData.filter(function sort(item) {
        return item !== undefined;
    });

    // visually separate milestones and gate, you can remove this function to have the lines ordered chronologically by tile number
    GameDefinitionData = GameDefinitionData.sort((a, b) => a.tableOrder - b.tableOrder);
    const [stage, setStage] = useState(0);
    if (gameDefinitionsShow == false) return null;
    if (title === 'Table' && stage == 0) {
        return (
            <MainContainer>
                <InnerContainer>
                    <HeaderContainer>
                        <TitleContainer>
                            <Title>{t('modals.budget_and_resources.info_title')}</Title>
                            <XContainer>
                                <X onClick={() => toggleGameDefinitions(false)} />
                            </XContainer>
                        </TitleContainer>
                        <ParagraphContainer>
                            <Paragraph>{t('modals.budget_and_resources.info_text')}</Paragraph>
                        </ParagraphContainer>
                    </HeaderContainer>
                    <GameDefinitionsMainContainer>
                        <FirstLineContainer>
                            <FirstLineItem style={{ marginLeft: '2.800rem' }}>
                                {t('modals.budget_and_resources.position')}
                            </FirstLineItem>
                            <FirstLineItem>
                                {t('modals.budget_and_resources.additional')}
                            </FirstLineItem>
                            <FirstLineItem>{t('global_variables.cost')}</FirstLineItem>
                            <FirstLineItem>
                                $100
                                <ManImages>
                                    <WhiteMan />
                                </ManImages>
                            </FirstLineItem>
                            <FirstLineItem>
                                $200
                                <ManImages>
                                    <RedMan />
                                </ManImages>
                            </FirstLineItem>
                            <FirstLineItem>
                                $500
                                <ManImages>
                                    <GreenMan />
                                </ManImages>
                            </FirstLineItem>
                        </FirstLineContainer>
                        <TableContainer>
                            {GameDefinitionData.map((current, index) => {
                                return <TableLine key={index} {...current} />;
                            })}
                        </TableContainer>
                    </GameDefinitionsMainContainer>
                </InnerContainer>
            </MainContainer>
        );
    }
}
